enum CarTypeEnum {
  SPORT = 'sport',
  SEDAN = 'sedan',
  SUV = 'suv',
  VAN = 'van',
}

export { CarTypeEnum }
